module.exports = __webpack_public_path__ + "static/img/news_program_5.41c3c629.jpg";